if (typeof jQuery != "undefined") {
    (function($) {
        "use strict";

        /* UpdateParticipant
        *
        * Update
        *
        * expects:
        * <someelement data-interaction="UpdateParticipant" data-lookup-url="url_of_lookup_webservice">
        *
        * */
        ZZ.UpdateParticipant = function(updateParticipantContainer) {
            var base = this;
            base.container = updateParticipantContainer;

            base.formFields = base.container.find('[type="checkbox"]');

            base.url = base.container.attr("data-lookup-url");
            base.ajaxMethod = base.container.attr("data-lookup-type");

            base.registerPanel = base.container.find(".register");
            base.submitBtn = base.registerPanel.find("button");
            base.participantId = "";

            base.config = {
                invalidClassName: "error",
                validClassName: "accord"
            };

            base.assignListeners();
        };

        ZZ.UpdateParticipant.prototype = {
            assignListeners: function() {
                var base = this;

                base.formFields.on("click", this.moveRegisterPanel.bind(this));
                base.submitBtn.on("click", this.update.bind(this));

                base.registerPanel.hide();
            },

            moveRegisterPanel: function(event) {
                var activeCheckBox = $(event.currentTarget);

                this.container
                    .find('.registerparent input[type="checkbox"]')
                    .prop("checked", false);
                this.container.find("tr").removeClass("registerparent");

                this.registerPanel.hide();
                this.fieldsValid();
                this.registerPanel.find("form")[0].reset();

                if (activeCheckBox.is(":checked")) {
                    var _parent = activeCheckBox.parents("tr");
                    this.registerPanel.insertAfter(_parent);
                    _parent.addClass("registerparent");
                    this.participantId = activeCheckBox.attr("data-id");
                    this.registerPanel.show();
                } else {
                    //close panel
                    this.registerPanel.find("form")[0].reset();
                    this.registerPanel.hide();
                }

                this.registerPanel
                    .find("#participant-id")
                    .val(this.participantId);
            },

            update: function(event) {
                event.preventDefault();
                var base = this;
                var parameters = base.registerPanel.find("form").serialize();

                base.registerPanel
                    .find("td")
                    .first()
                    .addClass("loading");
                // add ZZ specific security token
                var securityToken = $(":input[name=ZZCSRFToken]:first");
                if (
                    securityToken.length > 0 &&
                    base.ajaxMethod.toString().toUpperCase() !== "GET"
                ) {
                    parameters += "&" + securityToken.serialize();
                }
                base.submitBtn.attr("disabled", "disabled");

                $.ajax({
                    url: base.url,
                    dataType: "json",
                    type: base.ajaxMethod,
                    data: parameters,
                    redirLogout: true /* redirect in case logged out (redirect-proxy.js) */,
                    success: function(response) {
                        //response kan update met waarde ok of fieldname met fieldmessage bevattten of message met waarde
                        if (response.message !== undefined) {
                            base.serverError(response.message);
                        } else if (response.update !== undefined) {
                            if (
                                typeof response.update === "string" &&
                                response.update.toUpperCase() === "OK"
                            ) {
                                base.fieldsValid();

                                if (response.action) {
                                    base.updateRow(
                                        response.action[0].updatefieldclass,
                                        response.action[0].updatevalue
                                    );
                                }

                                base.registerPanel.hide();
                                base.registerPanel.find("form")[0].reset();
                                base.disableRow();
                            } else {
                                for (var prop in response.update) {
                                    if (response.update.hasOwnProperty(prop)) {
                                        var input = base.registerPanel.find(
                                            'input[name="' +
                                                response.update[prop]
                                                    .fieldname +
                                                '"]'
                                        );
                                        var message =
                                            response.update[prop].fieldmessage;
                                        base.fieldIsInvalid(input, message);
                                    }
                                }
                            }
                        }
                        base.registerPanel
                            .find("td")
                            .first()
                            .removeClass("loading");
                        base.submitBtn.removeAttr("disabled");
                    },
                    error: function() {
                        base.container.removeClass("loading");
                        base.submitBtn.removeAttr("disabled");
                    }
                });
            },

            updateRow: function(className, value) {
                var base = this;
                this.container
                    .find(".registerparent")
                    .find("." + className)
                    .html(value);
            },

            disableRow: function() {
                var base = this;
                this.container
                    .find(".registerparent")
                    .removeClass("registerparent")
                    .addClass("inactive");
                this.registerPanel.hide();
            },

            fieldsValid: function() {
                var base = this;
                base.container
                    .find("." + base.config.invalidClassName)
                    .removeClass(base.config.invalidClassName);
                base.container.find(".server-message").hide();
            },

            fieldIsInvalid: function(input, message) {
                var base = this,
                    inputWrapper = input.parent(),
                    messageNode = inputWrapper.find(".validation-message");

                if (messageNode.length === 0) {
                    messageNode = $('<p class="validation-message"></p>');
                    inputWrapper.append(messageNode);
                }
                messageNode.html(message);

                inputWrapper.removeClass(base.config.validClassName);
                inputWrapper.addClass(base.config.invalidClassName);
                input.removeClass(base.config.validClassName);
                input.addClass(base.config.invalidClassName);
            },

            serverError: function(message) {
                var base = this;
                var messageNode = base.container.find(".server-message");

                messageNode.html(message);
                messageNode.show();
            },

            cancel: function() {
                this.resultPanel.hide();
            }
        };
    })(jQuery);
}
